import React from 'react'
import { Icon } from './Icon'

export const TimeSpan = ({ startDate, endDate, iconProps }) => {
  return <span>
    <Icon className='fa fa-calendar-alt' {...iconProps} />
    {startDate}
    {!!endDate && <span> - {endDate}</span>}
  </span>
}